<template>
<div class="news dirr">
   <v-container>
        <div class="news_con">
            <div class="impoNews" v-if="lastNews_skeleton">
                <v-layout row>
                    <v-flex sm12 xs12 md8 lg8 style="padding:0 10px;">
                        <v-skeleton-loader  width="800" min-width="800" type="image"></v-skeleton-loader>
                        <v-skeleton-loader  width="800" min-width="800" type="card"></v-skeleton-loader>
                    </v-flex>
                    <v-flex sm12 xs12 md4 lg4 style="padding:0 10px;">
                        <v-skeleton-loader  class="mx-auto" width="350" min-width="350" max-width="350" type="paragraph, paragraph, paragraph, sentences, paragraph, sentences, actions"></v-skeleton-loader>
                    </v-flex>
                </v-layout>
            </div>
            <div class="impoNews" v-else>
                <div v-if="$i18n.locale == 'ar'" style="font-size: 34px; font-weight: bold; justify-content: center; text-align: center;">
                    <div style="display: inline-block;">
                        <!-- <div class="px-8 pb-1">المركز الخبري</div> -->
                        <div class="tl pt-2" style="font-size: 24px;">وكالة أنباء العتبة العباسية المقدسة</div>
                        <hr>
                        
                        <a href="mailto: news@alkafeel.net" style="text-decoration: none; font-size: 15px;color: darkgrey;"> <div class="tl">news@alkafeel.net</div></a>
                    </div>
                    
                </div>
                <div class="title" style="padding:0 20px 20px 20px;">
                    <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                    <router-link :to="'/newscat/all'+'?lang='+$i18n.locale" class="tl"> {{ $t("news_latest") }}</router-link>
                </div>
                <div class="items">
                    <div  class="item Fitem">
                    <v-layout row>
                        <v-flex sm12 xs12 md8 lg8 style="padding:0 10px;">
                        <router-link :to="'/new/'+latestNews[0]  .id+'?lang='+$i18n.locale" >
                            <!-- <img :src="'https://alkafeel.net/news/mcroped96/625/' + latestNews[0]  .image" :alt="latestNews[0]  .title" /> -->
                            <div class="img">
                                <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+latestNews[0]  .image"
                                    :src="'https://alkafeel.net/news/mcroped96/800/'+latestNews[0]  .image" style="border-radius: 4px;">
                                </v-img>
                                <div class="icon" v-if="latestNews[0]  .video">
                                    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                    <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                    </svg>
                                </div>
                                
                            </div>
                        </router-link>
                        </v-flex>
                        <v-flex sm12 xs12 md4 lg4 style="padding:0 10px;">
                            <div :class="'paregs ' + $store.state.direction">
                            <router-link :to="'/new/'+latestNews[0].id+'?lang='+$i18n.locale"  style="    text-decoration: none;">
                                <p class="tl" v-html="latestNews[0].title"></p>
                                
                                <p v-if="latestNews[0].text" :class="$i18n.locale=='ar' ? 'txx' : 'tx'" v-html="removebbcode(latestNews[0].text) + ' ...'"></p>
                            </router-link>
                                <div class="social d-none d-sm-flex">
                                    <a :href="'https://telegram.me/share/?url=https://alkafeel.net/news/index?id='+latestNews[0].id+'&lang='+$i18n.locale" target="_blank" class="telegram">
                                        <img :src="$vuetify.theme.dark ? '/assets/img/news/Telegram_white.svg' : '/assets/img/news/Telegram_dark.svg'" />
                                    </a>
                                    <a :href="'https://twitter.com/intent/tweet?text=https://alkafeel.net/news/index?id='+latestNews[0].id+'&lang='+$i18n.locale" target="_blank" class="twitter">
                                        <img :src="$vuetify.theme.dark ? '/assets/img/news/twitter_white.svg' : '/assets/img/news/twitter_dark.svg'" />
                                    </a>
                                    <a :href="'https://www.facebook.com/sharer/sharer.php?u=https://alkafeel.net/news/index?id='+latestNews[0].id+'&lang='+$i18n.locale" target="_blank" class="facebook">
                                        <img :src="$vuetify.theme.dark ? '/assets/img/news/Facebook_white.svg' : '/assets/img/news/Facebook_dark.svg'" />
                                    </a>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    </div>
                    <div class="sitems">
                        <v-layout row>
                            <v-flex xs12 sm6 md4 lg4  v-for="i in latestNews.slice(1)" :key="i" style="padding:8px 10px;">
                                <router-link :to="'/new/'+i.id+'?lang='+$i18n.locale" class="item Oitem">
                                    <div class="img">
                                        <img :src="'https://alkafeel.net/news/mcroped96/390/' + i.image" :alt="i.title" />
                                        <div class="icon" v-if="i.video">
                                            <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                            <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <div class="home_main_new_cat" style="bottom: 34px !important;">{{TimeSince(i.time)}}</div>
                                    </div>
                                    <p class="tl" v-html="$options.filters.subStrimpoNewsTitle(i.title)"></p>
                                </router-link>
                            </v-flex>
                        </v-layout>
                        <router-link :to="'/newscat/all'+'?lang='+$i18n.locale+'&more=1'" class="tl">
                            <v-btn  height="40" class="ma-2 tl" style="align-self:center;" :loading="loading" color="rgba(177, 189, 82, 1)">
                                <p class="alistSub tl">{{ $t('view_more') }}</p>
                            </v-btn>
                        </router-link>
                    </div>
                    <!-- <div class="slider">
                        <swiper class="swiper dirr" ref="mySwiper" :options="swiperOptions">
                            <swiper-slide v-for="i in latestNews.slice(1)" :key="i">
                                <router-link :to="'/new/'+i.id+'?lang='+$i18n.locale" class="item Oitem">
                                    <div class="img">
                                        <img :src="'https://alkafeel.net/news/mcroped96/390/' + i.image" :alt="i.title" />
                                        <div class="icon" v-if="i.video">
                                            <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                            <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <div class="home_main_new_cat" style="bottom: 34px !important;">{{TimeSince(i.time)}}</div>
                                    </div>
                                    <p class="tl">{{i.title | subStrimpoNewsTitle}}</p>
                                </router-link>
                            </swiper-slide>
                            <div class="swiper-pagination swiper-pagination-bullets d-none d-sm-none d-md-flex" slot="pagination"></div>
                        </swiper>
                    </div> -->
                </div>
            </div>
            <div class="lastNews" v-if="impoNews_skeleton">
                <v-layout row>
                    <v-flex sm12 xs12 md8 lg8 style="padding:0 10px;">
                        <v-skeleton-loader  width="800" min-width="800" type="image"></v-skeleton-loader>
                        <v-skeleton-loader  width="800" min-width="800" type="card"></v-skeleton-loader>
                    </v-flex>
                    <v-flex sm12 xs12 md4 lg4 style="padding:0 10px;">
                        <v-skeleton-loader  class="mx-auto" width="350" min-width="350" max-width="350" type="paragraph, paragraph, paragraph, sentences, paragraph, sentences, actions"></v-skeleton-loader>
                    </v-flex>
                </v-layout>
            </div>
            <div class="lastNews" v-else>
                <div class="title" style="padding:0 20px 20px 20px;">
                    <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                    <!-- <router-link :to="'/newscat/all'+'?lang='+$i18n.locale" class="tl"> {{ $t("news_sticky") }}</router-link> -->
                    <p class="tl"> {{ $t("news_sticky") }}</p>
                </div>
                <div class="items">
                    <v-layout row class="d-none d-sm-flex">
                        <v-flex sm12 xs12 md6 lg5 style="padding:0 10px;">
                            <router-link :to="'/new/'+impoNews[0].id+'?lang='+$i18n.locale" class="item Fitem">
                                <!-- <img :src="'https://alkafeel.net/news/mcroped96/625/' + latestNews[0]  .image" :alt="latestNews[0]  .title" /> -->
                                <div class="img">
                                    <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+impoNews[0]  .image"
                                        :src="'https://alkafeel.net/news/mcroped96/625/'+impoNews[0]  .image" style="height: 100%; width: 100%; border-radius: 4px;">
                                    </v-img>
                                    <div class="icon" v-if="impoNews[0]  .video">
                                        <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                        <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                        </svg>
                                    </div>

                                    <div class="home_main_new_cat" style="bottom: 34px !important;">

                                    <!-- {{moment.unix(item.time).locale($i18n.locale).fromNow()}} -->
                                        {{TimeSince(impoNews[0].time)}}

                                    </div>
                                </div>
                                <p class="tl" v-html="impoNews[0].title"></p>
                                <p v-if="impoNews[0].text" :class="$i18n.locale=='ar' ? 'txx' : 'tx'" v-html="removebbcode(impoNews[0].text) + ' ...'"></p>
                            </router-link >
                        </v-flex>
                        <v-flex sm12 xs12 md6 lg7 style="padding:0 10px;">
                            <router-link :to="'/new/' + i.id + '?&lang=' +$i18n.locale" v-for="i in impoNews.slice(1)" :key="i" class="item Oitem" >
                                <div :class="'paregs ' + $store.state.direction">
                                    <p class="tl" v-html="i.title"></p>
                                    <p :class="$i18n.locale=='ar' ? 'txx' : 'tx'" v-html="vhtmlText(i.text)"></p>
                                </div>
                                <div class="img">
                                    <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                                        :src="'https://alkafeel.net/news/mcroped96/260/'+i.image" style="height: 100%; width: 100%; border-radius: 4px;">
                                    </v-img>
                                    <div class="icon" v-if="i.video">
                                        <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                        <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                        </svg>
                                    </div>

                                    <div class="home_main_new_cat" style="bottom: 34px !important;">

                                    <!-- {{moment.unix(item.time).locale($i18n.locale).fromNow()}} -->
                                        {{TimeSince(i.time)}}

                                    </div>
                                    
                                </div>
                            </router-link>
                        </v-flex>
                    </v-layout>
                    <router-link :to="'/new/' + i.id + '?&lang=' +$i18n.locale" v-for="i in impoNews" :key="i" class="item Oitem d-flex d-sm-none" style="margin:20px 10px;">
                        <div :class="'paregs ' + $store.state.direction">
                            <p class="tl" v-html="i.title"></p>
                            <p class="tx d-none d-sm-flex" v-html="vhtmlText(i.text)"></p>
                        </div>
                        <!-- <img :src="'https://alkafeel.net/news/mcroped96/625/' + i.image" :alt="i.title" /> -->
                        <div class="img">
                            <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                                :src="'https://alkafeel.net/news/mcroped96/625/'+i.image" style="height: 100%; width: 100%; border-radius: 4px;">
                            </v-img>
                        </div>
                    </router-link>
                </div>
            </div>





            <div class="lastNews" v-if="reportNews.length > 0">
            <div class="title" style="padding:0 20px 20px 20px;">
                <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                <router-link :to="'/new/reports'+'?lang='+$i18n.locale" class="tl">{{ $t("news_reports") }}</router-link>
            </div>
            <div class="items">
                <v-layout row class="d-none d-sm-flex">
                    <v-flex sm12 xs12 md6 lg5 style="padding:0 10px;">
                        <router-link :to="'/new/'+reportNews[0].id+'?lang='+$i18n.locale" class="item Fitem">
          
                            <div class="img">
                                <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+reportNews[0]  .image"
                                    :src="'https://alkafeel.net/news/mcroped96/625/'+reportNews[0]  .image" style="height: 100%; width: 100%; border-radius: 4px;">
                                </v-img>
                                <div class="icon" v-if="reportNews[0].video">
                                    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                    <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                    </svg>
                                </div>

                                <div class="home_main_new_cat" style="bottom: 34px !important;">

                                    {{TimeSince(reportNews[0].time)}}

                                </div>
                            </div>
                            <p class="tl" v-html="reportNews[0].title"></p>
                            <p v-if="reportNews[0].text" :class="$i18n.locale=='ar' ? 'txx' : 'tx'" v-html="removebbcode(reportNews[0].text) + ' ...'"></p>
                        </router-link >
                    </v-flex>
                    <v-flex sm12 xs12 md6 lg7 style="padding:0 10px;">
                        <router-link :to="'/new/' + i.id + '?&lang=' +$i18n.locale" v-for="i in reportNews.slice(1)" :key="i" class="item Oitem" >
                            <div :class="'paregs ' + $store.state.direction">
                                <p class="tl" v-html="i.title"></p>
                                <p :class="$i18n.locale=='ar' ? 'txx' : 'tx'" v-html="vhtmlText(i.text)"></p>
                            </div>
                            <div class="img">
                                <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                                    :src="'https://alkafeel.net/news/mcroped96/260/'+i.image" style="height: 100%; width: 100%; border-radius: 4px;">
                                </v-img>
                                <div class="icon" v-if="i.video">
                                    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="27.1089" cy="27.7103" r="26.8329" fill="#B1BD52" fill-opacity="0.8"/>
                                    <path d="M39.0253 26.8443C39.692 27.2292 39.692 28.1915 39.0253 28.5764L21.9007 38.4633C21.234 38.8482 20.4007 38.3671 20.4007 37.5973V17.8235C20.4007 17.0537 21.234 16.5725 21.9007 16.9574L39.0253 26.8443Z" fill="white"/>
                                    </svg>
                                </div>

                                <div class="home_main_new_cat" style="bottom: 34px !important;">
                                    {{TimeSince(i.time)}}
                                </div>
                                
                            </div>
                        </router-link>
                    </v-flex>
                </v-layout>
                <router-link :to="'/new/' + i.id + '?&lang=' +$i18n.locale" v-for="i in reportNews" :key="i" class="item Oitem d-flex d-sm-none" style="margin:20px 10px;">
                    <div :class="'paregs ' + $store.state.direction">
                        <p class="tl" v-html="i.title"></p>
                        <p class="tx d-none d-sm-flex" v-html="vhtmlText(i.text)"></p>
                    </div>
                    
                    <div class="img">
                        <v-img :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                            :src="'https://alkafeel.net/news/mcroped96/625/'+i.image" style="height: 100%; width: 100%; border-radius: 4px;">
                        </v-img>
                    </div>
                </router-link>
            </div>
        </div>







            <div class="picNews zx" v-if="$i18n.locale === 'ar'">
                <div class="title">
                    <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                    <router-link :to="'/new/photo'+'?lang='+$i18n.locale" class="tl">{{ $t("Picture_Reports") }}</router-link>
                </div>
                <div class="items">
                    <v-container class="infograph">
                        <v-layout row class="inf m-2">
                            <v-col cols="12" md="6" lg="4" style="margin-bottom: 50px;" v-for="(card, index) in picNews" :key="index">
                                <transition name="fade">

                                    <div class="video-wrapper" v-if="card.video_file">
                                        <router-link  :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale">
                                            <video @mouseenter="playVideo" @mouseleave="pauseVideo" @touchstart="playVideo" @touchend="pauseVideo" muted :poster="'https://alkafeel.net/news/images/main/370/' + card.image" :src="'https://alkafeel.net/news/images/infograph/'+card.video_file" class="image-hover-scale full-height-img video-container" ></video>
                                        </router-link>
                                        <button v-if="!isPlaying" class="play-btn" @click="togglePlay">
                                            <span class="play-icon">{{ isPlaying ? '❚❚' : '▶' }}</span>
                                        </button>
                                    </div>
                                        
                                    <v-carousel :cycle="index === 0" interval="3000" :show-arrows="false">
                                        <v-carousel-item v-for="(image, i) in [card.image, ...card.images]" :key="i">
                                            <router-link :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale" class="inf_item">
                                                <img :src="image.includes('http') ? image : 'https://alkafeel.net/news/images/main/370/' + image" class="image-hover-scale full-height-img">
                                            </router-link>
                                        </v-carousel-item>
                                    </v-carousel>
                                </transition>
                            </v-col>
                        </v-layout>
                    </v-container>
                </div>
            </div>

            
        </div>
        <div class="videoNews mt-6" >
            <div class="title" style="padding:0 20px 20px 20px;">
                <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                <router-link :to="'/new/video'+'?lang='+$i18n.locale" class="tl">{{ $t("Video_Reports") }}</router-link>
            </div>
            <div class="items">
                <div class="slider" style="width: 100%;">
                    <div :class="'sbtn lbtn d-none d-lg-flex d-xl-flex '+ $store.state.direction"></div>
                    <swiper class="swiper mx-h dirr" ref="mySwiper" :options="swiperOptions3">
                        <swiper-slide v-for="i in videoNews" :key="i">
                        <router-link :to="'/new/' + i.id + '?&lang=' +$i18n.locale" class="item" >
                            <div class="img_con">
                                <div class="play">
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="32" cy="32" r="32" fill="#B1BD52" fill-opacity="0.8"/>
                                    <path d="M46.5 31.134C47.1667 31.5189 47.1667 32.4811 46.5 32.866L25.5 44.9904C24.8333 45.3753 24 44.8942 24 44.1244L24 19.8756C24 19.1058 24.8333 18.6247 25.5 19.0096L46.5 31.134Z" fill="white"/>
                                </svg>
                                </div>
                                <img :src="'https://alkafeel.net/news/mcroped96/330/' + i.image" :alt="i.title"/>
  
                            </div>
                            <p class="tl" style="min-height:55px;" v-html="$options.filters.subStrvideoNewsTitle(i.title)"></p>
                            
                        </router-link>
                        </swiper-slide>
                    </swiper>
                    <div :class="'sbtn rbtn d-none d-lg-flex d-xl-flex '+ $store.state.direction"></div>
                </div>
            </div>
        </div>






    <div class="news_con">





        



        <div class="picNews" v-if="interviewNews.length > 0">
            <div class="title">
                <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                <router-link :to="'/new/interviews'+'?lang='+$i18n.locale" class="tl">{{ $t("news_interviews") }}</router-link>
            </div>
            <div class="items">
            <v-container>
                    <v-layout row>
                    <v-flex sm6 xs12 md4 lg4 v-for="i in interviewNews" :key="i" style="padding:0 5px;">
                        <router-link class="fill-height item" :to="'/new/' + i.id + '?&lang=' +$i18n.locale">
                            <img  :src="'https://alkafeel.net/news/mcroped96/390/' + i.image" :alt="i.title" />
                            <div class="p_con tl" v-html="$options.filters.subStrArtTitle(i.title)"></div>
                        </router-link>
                    </v-flex>
                </v-layout>
            </v-container>
            </div>
        </div>



    </div>





        <news-search></news-search>
   </v-container>
</div>
</template>


<script>

import searchVue from './search.vue';
export default {
    data() {
        return {
            isPlaying: false,
            impoNews : [],
            reportNews : [],
            interviewNews : [],
            latestNews : [],
            picNews:[],
            videoNews:[],
            impoNews_skeleton : true,
            lastNews_skeleton : true,
            swiperOptions: {
                slidesPerView: 'auto',
                   autoplay: {
                        delay: 10000,
                        disableOnInteraction: true,
                    },
                spaceBetween: 30,
                freeMode: true,
                keyboard: true,
                // autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                
            },
            swiperOptions2: {
                slidesPerView: "auto",
                spaceBetween:40,
                loop:true,
                freeMode: true,
                navigation: {
                    nextEl: ".rbtn2",
                    prevEl: ".lbtn2",
                },
                keyboard: true,
            },
            swiperOptions3: {
                slidesPerView: 'auto',
                autoplay: {
                        delay: 19400,
                        disableOnInteraction: true,
                    },
                spaceBetween: 20,
                freeMode: true,
                keyboard: true,
                loop: true,
            
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: ".rbtn",
                    prevEl: ".lbtn",
                },
            },



            
        }
    },
    computed: {
        swiper() {return this.$refs.mySwiper.$swiper}
    },
    mounted() {
        document.title =this.$t("news"); 
    }, 
    created () {
        this.getlatestNews();
        this.getpicNews();
        this.getvideoNews();
        this.grtimpoNews ();
        this.getreportNews ();
        this.getinterviewNews ();
    },
    components: {
        'news-search': searchVue
    },
    methods:{
        playVideo(event) {
            const video = event.target;
            video.play();
            this.isPlaying = true; // Update state to playing
        },
        pauseVideo(event) {
            const video = event.target;
            video.pause();
            this.isPlaying = false; // Update state to paused
        },
        togglePlay(event) {
            const video = event.target.closest('.video-wrapper').querySelector('video');
            if (video.paused) {
            video.play();
            this.isPlaying = true; // Update state to playing
            } else {
            video.pause();
            this.isPlaying = false; // Update state to paused
            }
        },
        updatePlayIcon(event) {
            const video = event.target;
            this.isPlaying = !video.paused; // Sync state with video's playback state
        },
        TimeSince: function (date) {
            date =date*1000;
            var seconds = Math.floor((new Date() - date) / 1000);
            var interval = seconds / 31536000;
            if (this.$i18n.locale === 'tr' || this.$i18n.locale === 'pr') {
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_year") +' '+ this.$t("time_before");}
                interval = seconds / 2592000;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_month") +' '+ this.$t("time_before");}
                interval = seconds / 86400;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_day") +' '+ this.$t("time_before");}
                interval = seconds / 3600;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_hour") +' '+ this.$t("time_before");}
                interval = seconds / 60;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_min") +' '+ this.$t("time_before");}
                return Math.floor(seconds) +' '+ this.$t("time_sec") +' '+ this.$t("time_before");
            } else {
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_year");}
                interval = seconds / 2592000;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_month");}
                interval = seconds / 86400;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_day");}
                interval = seconds / 3600;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_hour");}
                interval = seconds / 60;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_min");}
                return this.$t("time_before") +' '+ Math.floor(seconds) +' '+ this.$t("time_sec");
            }
            
        },
        grtimpoNews () {
            this.$axios.get("articles/GetImportant/4", {
            })
            .then(res => {
                this.impoNews = res.data;
                setTimeout(() => this.impoNews_skeleton = false, 500);
                //console.log(res.data);
            })
            .catch(() => {
            });
        },


        getreportNews () {
            this.$axios.get("articles/Getreportnews/4?page=1", {
            })
            .then(res => {
                this.reportNews = res.data.data;
            })
        },
        getinterviewNews () {
            this.$axios.get("articles/Getinterviewnews/6?page=1", {
            })
            .then(res => {
                this.interviewNews = res.data.data;
            })
        },

        getlatestNews () {
            this.$axios.get("articles/GetByLimit/7", {
            })
            .then(res => {
                this.latestNews = res.data;
                setTimeout(() => this.lastNews_skeleton = false, 500);
            })
        },
        getpicNews() {
            this.$axios.get("articles/GetInfograph/3/0?page=1", {
            })
            .then(res => {
                this.picNews = res.data.data;
            })
        },
        getvideoNews() {
            this.$axios.get("articles/GetVideosNews/6?page=1", {
            })
            .then(res => {
                this.videoNews = res.data.data;
            })
        },
        vhtmlText (i) {
            if (i != null) {return this.stripHTML(i.replace(/\[\/?[^\]]*\]/g, '').substring(0, 110) + '...')}
        },
        removebbcode (x) {
            if (x) {return this.stripHTML(x.replace(/\[\/?[^\]]*\]/g, ''))}
        },
        stripHTML (value) {
            const div = document.createElement('div')
            div.innerHTML = value
            const text = div.textContent || div.innerText || ''
            return text
        }
    },
    filters: {
        subStrvideoNewsTitle: function (string) {if (string != null) {return string.substring(0, 65) + '...';}},
        subStrimpoNewsTitle: function (string) {if (string != null) {return string.substring(0, 80) + '...';}},
        subStrArtTitle: function (string) {if (string != null) {return string.substring(0, 85) + '...';}},
        FormatDate: function (unixTime) {
            let d = new Date(unixTime*1000);
            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
            let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
            return (`${da}-${mo}-${ye}`);
        },
    },
}
</script>

<style>

.full-height-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
}
.video-container {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}
.full-height-img:hover {
    transform: scale(1.05);
}

.video-wrapper {
  position: relative;
  display: inline-block;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.play-btn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.play-icon {
  margin-left: 4px;
}

.inf .v-carousel {
    overflow:visible
}
.inf .v-carousel__controls .v-icon {
    font-size: 8px;
}
.inf .v-carousel__controls {
    position: relative;
    background: transparent;
}
.inf .mdi-circle::before {
    content: ""!important;
}
.inf .v-carousel__controls__item.v-btn.v-btn--icon {
    background-color: #000; 
    width: 10px;
    height: 10px;
}
  
.inf .v-carousel__controls__item.v-btn.v-btn--icon.v-btn--active {
    background-color: #cac2c2; 
}

.inf .v-carousel__controls__item.v-btn.v-btn--icon:hover {
    background-color: black; 
}



</style>

<style lang="scss" scoped>
.inf_item {
    display: block;
    height: 100%;
}
.inf {
    margin: -12px !important;
}

.infograph {
    padding: 0 !important;
}

.mx-h {
    max-height: 400px;
}

.swiper-slide {
    background: transparent !important;
}
</style>